<template lang="pug">
el-drawer.email-preview-drawer(
    :title="$t('Email Preview')"
    :visible="visible"
    direction="rtl"
    size="40%"
    :before-close="handleClose"
)
    .drawer-content(v-loading="loading")
        template(v-if="email")
            //- Minimalistic email meta header
            .meta
                .from-to
                    .from
                        b {{ $t('From') }}:
                        span.pill {{ formatSender(email) }}
                    .to
                        b {{ $t('To') }}:
                        span.pill {{ formatRecipient(email) }}
                .subject
                    b {{ $t('Subject') }}:
                    span {{ email.subject }}
                .stats(v-if="email.opens > 0 || email.clicks > 0")
                    span.stat(v-if="email.opens > 0")
                        | {{ email.opens }} {{ $t(email.opens === 1 ? 'open' : 'opens') }}
                    span.stat(v-if="email.clicks > 0")
                        | {{ email.clicks }} {{ $t(email.clicks === 1 ? 'click' : 'clicks') }}

            //- Email content iframe
            section.body
                iframe(
                    ref="emailFrame"
                    :srcdoc="email.content"
                    sandbox="allow-same-origin"
                    frameBorder="0"
                    @load="adjustIframeHeight"
                )
</template>

<i18n>
{
    "de": {
        "Email Preview": "E-Mail Vorschau",
        "From": "Von",
        "To": "An",
        "Subject": "Betreff",
        "open": "Geöffnet",
        "opens": "Geöffnet",
        "click": "Klick",
        "clicks": "Klicks"
    }
}
</i18n>

<script>
import { useNewsletterNewsletterStore } from '@/stores'

export default {
    name: 'SentEmailPreviewDrawer',
    computed: {
        newsletterStore() {
            return useNewsletterNewsletterStore()
        },
        emailPreview() {
            return this.newsletterStore.emailPreview
        },
        visible() {
            return this.emailPreview && this.emailPreview.visible
        },
        loading() {
            return this.emailPreview && this.emailPreview.loading
        },
        email() {
            return this.emailPreview && this.emailPreview.email
        }
    },
    methods: {
        closeEmailPreview() {
            this.newsletterStore.closeEmailPreview()
        },
        handleClose() {
            this.closeEmailPreview()
        },
        formatSender(email) {
            if (email.sender_name) {
                return `${email.sender_name} <${email.sender_email}>`
            }
            return email.sender_email
        },
        formatRecipient(email) {
            if (email.recipient_name) {
                return `${email.recipient_name} <${email.recipient_email}>`
            }
            return email.recipient_email
        },
        adjustIframeHeight() {
            const iframe = this.$refs.emailFrame
            if (iframe && iframe.contentDocument) {
                const height = iframe.contentDocument.body.scrollHeight
                iframe.style.height = Math.max(height + 20, 400) + 'px'
            }
        }
    }
}
</script>

<style lang="sass" scoped>
.email-preview-drawer
    ::v-deep .el-drawer
        min-width: 600px
        max-width: 90%
        .el-drawer__body
            display: flex
            flex-direction: column
            overflow: hidden

.drawer-content
    height: 100%
    display: flex
    flex-direction: column
    overflow: hidden

.meta
    padding: 20px
    padding-top: 0
    flex-shrink: 0
    font-size: 0.8rem
    display: grid
    grid-template-rows: auto auto
    grid-template-columns: auto auto

    .from-to
        .from,
        .to
            b
                margin-right: 4px
        .pill
            margin-left: 4px
            &:not(:last-child):after
                content: ', '
                margin-right: 2px

    .subject
        grid-row: 2
        margin-top: 1rem
        b
            margin-right: 4px

    .stats
        grid-column: 2
        text-align: right
        color: #909399
        font-size: 12px
        .stat
            &:not(:last-child):after
                content: ' | '

.body
    flex-grow: 1
    width: 100%
    overflow-y: auto

    iframe
        display: block
        width: 100%
        min-height: 100%
        border: none
</style>
